import styled from "../../styled-components.mjs";
import { cssLayoutMargin, cssSpacing } from "../../styles/index.mjs";
export var Body = styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-aotjrb-0"
})(["flex:1;-ms-overflow-style:-ms-autohiding-scrollbar;overflow:hidden auto;padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";"], cssSpacing('looser-2', '32px'), cssSpacing('looser-3', '48px'), cssLayoutMargin('base', '24px'), cssLayoutMargin('base', '24px'));